define([
  "globals",
  "jquery",
  "knockout",
  "underscore",
  "cookies-factory",
  "feature!colorbox-confirm"],
function (globals, $, ko, _, cookiesFactory, ColorboxConfirm) {

  const isTHD = globals.siteId === 11
  if (isTHD) {
    if (!cookiesFactory.isInternalUser()) {
      $('body').removeClass('mt5 is-internal-user');
      $('#mounted-header').removeClass('mt5');
      return {}
    } else {
      $('body').addClass('mt5');
      $('body').addClass('mt5 is-internal-user');
      $('#mounted-header').addClass('mt5');
      $('#summary').addClass('pt5 pt0-ns');
    }
  }

  var jQuerySelectorResult = $("#internal-user-sticky");
  if (jQuerySelectorResult.length !== 1) {
    return {}
  }
  
  if (cookiesFactory.isInternalUser()) {
    $(".bdc-header-spacer-for-stickies").show();  
  }

  var dateAsOfText = cookiesFactory.dateAsOf();
  var showDateAsOfSticky = true;
  if (!dateAsOfText) {
    dateAsOfText = "TODAY";
    showDateAsOfSticky = false;
  }

  var shouldShowOnBehalfOfDropdown = ko.observable(false);
  $(document).on("click", function() {
    shouldShowOnBehalfOfDropdown(false);
  });

  var emptyCart = function() {
    $.post('/Cart/Empty', function(response) {
      if (response) {
        window.location.reload();
      }
    });
  };

  var logoutOnBehalfOf = function() {
    new ColorboxConfirm({
      title: "Log off",
      msg: "Do you want to stop navigating on behalf of the customer?<br/>This leaves your login and cart unchanged.",
      buttons: {
        ok: {
          text: "Ok"
        },
        cancel: {
          text: "Cancel"
        }
      }
    }, function() {
      window.location = globals.globalPaths.logOutURI;
    });
  };

  var logout = () => {
    $.ajax({
      url: "/InternalUser/LogoutAndRemoveCookie",
    }).done((d) => {
      window.location = "/";
    });
  };

  var vm = {
    cartOnBehalfOf: cookiesFactory.cartOnBehalfOf(),
    dateAsOfText: dateAsOfText,
    logoutOnBehalfOf: logoutOnBehalfOf,
    shouldShowOnBehalfOfDropdown: shouldShowOnBehalfOfDropdown,
    showDateAsOfSticky: showDateAsOfSticky,
    username: cookiesFactory.userNameWithoutDomainPrefix(),
    employeeId: cookiesFactory.employeeId(),
    emptyCart: emptyCart,
    visible: cookiesFactory.isInternalUser(),
    logout: logout,
  }

  ko.applyBindings(vm, jQuerySelectorResult[0]);

  return {}

});
